import React, { ReactNode } from "react";

interface GlossaryProps {
  term: string;
  definition: string;
  label?: string;
  children?: ReactNode;
}

export const Glossary: React.FC<GlossaryProps> = ({
  term,
  definition,
  label,
  children,
}) => {
  return (
    <span className="gloss" tabIndex={0}>
      {children || term}
      <span className="gloss__pop">
        <strong>{label || term}</strong>
        {definition}
      </span>
    </span>
  );
};
